@if (vm$ | async; as vm) {
  <div
    class="bolt-container-fluid help-padding"
    [formGroup]="form"
    [nwxExposeFormErrors]="form"
    formName="vehicle-{{ vehicle?.vehicleId }}"
    [submitted]="submitted"
    >
    <div class="bolt-row">
      @if (vm.showVin) {
        <div class="bolt-col">
          @switch (vehicle?.productType) {
            @case ('PersonalAuto') {
              @if (
                !!vehicle?.productType && vehicle?.productType === 'PersonalAuto'
                ) {
                <nwx-vin-form
                  attr.taskElementId="vin-{{ vehicle?.vehicleId }}"
                  [vehicleIndex]="index"
                  [vehicle]="vehicle || {}"
                  (valueChange)="onValueChange($event)"
                  (formReady)="addChildForm('vin', $event)"
                ></nwx-vin-form>
              }
            }
            @case ('MSA') {
              @if (!!vehicle?.productType && vehicle?.productType === 'MSA') {
                <nwx-msa-vin-form
                  attr.taskElementId="vin-{{ vehicle?.vehicleId }}"
                  [vehicle]="vehicle || {}"
                  [vehicleIndex]="index"
                  (valueChange)="onValueChange($event)"
                  (formReady)="addChildForm('vin', $event)"
                ></nwx-msa-vin-form>
              }
            }
            @case ('RV') {
              @if (!!vehicle?.productType && vehicle?.productType === 'RV') {
                <bolt-textfield
                  attr.taskElementId="vin-{{ vehicle?.vehicleId }}"
                  label="VIN"
                  instructionaltext="VIN required for bindable rate."
                  formControlName="vin"
                  name="vin"
                ></bolt-textfield>
              }
            }
          }
        </div>
      }
      @if (vm.showHin) {
        <div class="bolt-col">
          <bolt-textfield
            label="HIN"
            instructionaltext="HIN required for bindable rate."
            attr.taskElementId="hin-{{ vehicle?.vehicleId }}"
            formControlName="hin"
            name="hin"
          ></bolt-textfield>
        </div>
      }
      @if (vm.showAnnualMiles) {
        <div class="bolt-col">
          <bolt-textfield
            label="Annual miles driven"
            formControlName="annualMiles"
            name="annualMiles"
            type="number"
            required
          ></bolt-textfield>
        </div>
      }
    </div>
  </div>
}
